import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { AlertColor } from '@mui/material/Alert';
import { AlertStyled, getColorByStatus } from './j-snack-bar.styled';
import {
  CheckIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';
import { IconSize } from '@constants';

interface JSnackbarProps {
  open: boolean;
  message: string;
  type: AlertColor;
  onClose: () => void;
}

const renderIcon = (type: AlertColor, color: string) => {
  switch (type) {
    case 'success':
      return <CheckIcon height={IconSize.md} color={color} />;
    case 'error':
      return <ExclamationTriangleIcon height={IconSize.md} color={color} />;

    default:
      return <CheckIcon height={IconSize.md} color={color} />;
  }
};

const JSnackbar: React.FC<JSnackbarProps> = ({
  open,
  message,
  type,
  onClose,
}) => {
  return (
    <Snackbar
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
    >
      <AlertStyled data-qa="snackbar-message" onClose={onClose} severity={type}>
        {message}
        {renderIcon(type, getColorByStatus(type))}
      </AlertStyled>
    </Snackbar>
  );
};

export default JSnackbar;
